import { useEffect, useState } from "react";
import close1 from "../../../assets/images/model/close.svg";
import downArrow from "../../../assets/images/chevron-down.svg";
import { useNavigate } from "react-router-dom";
import { book as createBook } from "../../../Store/api/create";
import { TagsInput } from "react-tag-input-component";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { associateABook, classInfo } from "../../../Store/api/classApi";
import { toast } from "react-toastify";
import { all, show } from "../../../Store/api/books";
const CreateNewBook = ({ setCreateNewBook, setSelectOption, mode }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [error, setError] = useState("");
  const [title, setTitle] = useState("");
  const [selected, setSelected] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [collaborator, setCollaborator] = useState("");
  const [categoryType, setCategoryType] = useState(false);
  const [materialType, setMaterialType] = useState(false);
  const [selectedMaterial, setSelectedMaterial] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const { classes } = useSelector((state) => state.entities.classes);
  const emptyClass = classes?.filter((clas) => !clas.isBookAssociated)[0];

  const MaterialTypeToogle = () => {
    setMaterialType(!materialType);
  };
  const CategoryTypeToogle = () => {
    setCategoryType(!categoryType);
  };
  const handleSelectMaterial = (selectedItem) => {
    setSelectedMaterial(selectedItem);
    setMaterialType(false); // Close the dropdown after selecting
  };
  const handleSelectCategory = (selectedItem) => {
    setSelectedCategory(selectedItem);
    setCategoryType(false);
  };

  useEffect(() => {
    setError("");
  }, [selected, selectedCategory, selectedMaterial, title, collaborator]);

  const handleInputChange = (event) => {
    setInputValue(event.target.value);
  };

  const handleAddTag = () => {
    if (inputValue.trim() !== "" && selected.length <= 3) {
      setSelected([...selected, inputValue.trim()]);
      setInputValue("");
    }
  };

  useEffect(() => {
    const tagsInput = document.querySelector(".react-tagsinput-input");
    if (tagsInput) {
      tagsInput.setAttribute("autocomplete", "off");
    }
  }, []);

  const validateBeforeChange = (_, existingTags) => {
    if (existingTags.length > 2) return false;
    return true;
  };

  /* .............. */
  return (
    <div
      className="modal custom_background  custom_modal_create"
      style={{ display: "block" }}
      id="create_new_book"
      tabIndex="-1"
      aria-labelledby="create_new_bookLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <img
                src={close1}
                alt="close"
                onClick={() => {
                  setCreateNewBook(false);
                  if (mode !== "app") {
                    setSelectOption(false);
                  }
                }}
              />
            </button>
          </div>
          <div className="modal-body-cre">
            <h4>create a new book</h4>
            <p>
              Fill out basic information and invite other authors to help. You
              can always change or add to this information later in greyled
              <span className="tech-color">teach</span>.
            </p>
            <form action="" className="create_new_book">
              <div className="create_new_book_filter my-40">
                <div className="form-group mb-45">
                  <input
                    type="text"
                    className="form-control pl_0"
                    placeholder="Title"
                    value={title}
                    onChange={(e) => {
                      setTitle(e.target.value);
                    }}
                  />
                  <span className="error-create" style={{ display: "none" }}>
                    please select title
                  </span>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group mb-45">
                      <div className="select_wrap_create">
                        <div
                          className={`cursor_pointer form-control pl_0 custom_select_create text-grey-create d-flex justify-content-between mb-0 ${
                            materialType ? "open" : ""
                          }`}
                          onClick={MaterialTypeToogle}
                        >
                          {selectedMaterial
                            ? selectedMaterial
                            : "Material type"}
                          {!materialType && <img src={downArrow} alt="ico here" style={{ marginRight: "10px"}} />}
                        </div>
                        {materialType && (
                          <div
                            className="drop_down_list_create"
                            style={{ display: "block" }}
                          >
                            <ul>
                              <li
                                onClick={() => handleSelectMaterial("Textbook")}
                              >
                                Textbook
                              </li>
                              <li
                                onClick={() =>
                                  handleSelectMaterial("Research Article")
                                }
                              >
                                Research Article
                              </li>
                              <li
                                onClick={() =>
                                  handleSelectMaterial("Media Article")
                                }
                              >
                                Media Article
                              </li>
                              <li onClick={() => handleSelectMaterial("Other")}>
                                Other
                              </li>
                            </ul>
                          </div>
                        )}
                      </div>
                      <span
                        className="error-create"
                        style={{ display: "none" }}
                      >
                        please select title
                      </span>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group mb-45">
                      <div className="select_wrap_create">
                        <div className={`cursor_pointer form-control pl_0 custom_select_create text-grey-create mb-0 d-flex justify-content-between ${
                            categoryType ? "open" : ""
                          }`}
                          onClick={CategoryTypeToogle}
                        >
                          {selectedCategory ? selectedCategory : "Category"}
                          {!categoryType && <img src={downArrow} alt="ico here" style={{ marginRight: "10px"}} />}
                        </div>
                        {categoryType && (
                          <div className="drop_down_list_create">
                            <ul>
                              <li onClick={() => handleSelectCategory("Arts")}>
                                Arts
                              </li>
                              <li
                                onClick={() => handleSelectCategory("Business")}
                              >
                                Business
                              </li>
                              <li
                                onClick={() =>
                                  handleSelectCategory("Education")
                                }
                              >
                                Education
                              </li>
                              <li
                                onClick={() =>
                                  handleSelectCategory("Engineering")
                                }
                              >
                                Engineering
                              </li>
                              <li
                                onClick={() =>
                                  handleSelectCategory("Healthcare")
                                }
                              >
                                Healthcare
                              </li>
                              <li
                                onClick={() =>
                                  handleSelectCategory("Humanities")
                                }
                              >
                                Humanities
                              </li>
                              <li
                                onClick={() =>
                                  handleSelectCategory(
                                    "Journalism, Media Studies.."
                                  )
                                }
                              >
                                Journalism, Media Studies & Communications
                              </li>
                            </ul>
                          </div>
                        )}
                      </div>
                      <span
                        className="error-create"
                        style={{ display: "none" }}
                      >
                        please select title
                      </span>
                    </div>
                  </div>
                </div>
                <div className="form-group mb-45">
                  <div className="add_value_wrap-create">
                    <div className="add_vlue_input_tage">
                      <TagsInput
                        value={selected}
                        onChange={setSelected}
                        name="fruits"
                        autoComplete="off"
                        placeHolder="Subject tags (add one at a time)"
                        className="form-control pl_0"
                        onKeyUp={handleInputChange}
                        beforeAddValidate={validateBeforeChange}
                      />
                      <span className="add_tages">{selected.length}/3</span>
                    </div>
                    <button
                      type="button"
                      className="add_btn_value_create"
                      onClick={handleAddTag}
                      disabled={selected.length >= 3} // Disable button when the tag count reaches 3
                    >
                      Add
                    </button>
                  </div>
                </div>
                <div className="form-group mb-45">
                  <input
                    type="email"
                    className="form-control pl_0"
                    placeholder="Invite a collaborator by email"
                    value={collaborator}
                    onChange={(e) => {
                      setCollaborator(e.target.value);
                    }}
                  />
                  <span className="error-create" style={{ display: "none" }}>
                    please enter email
                  </span>
                </div>
              </div>
              {error && (
                <p
                  className="mb-1"
                  style={{
                    color: "red",
                    fontWeight: 400,
                    lineHeight: "150%",
                    fontFamily: "Inter",
                    fontSize: "14px",
                    textAlign: "center",
                  }}
                >
                  {error}
                </p>
              )}
              <div className="modal-btn">
                <button
                  type="button"
                  disabled={isLoading}
                  className="btn-black_create mb-24"
                  onClick={() => {
                    let error = "";
                    if (!title) error = "Title is required.";
                    if (!selectedCategory) error = "Category is required.";
                    if (!selectedMaterial) error = "Material type is required.";
                    if (error) {
                      setError(error);
                      return;
                    }
                    setIsLoading(true);
                    dispatch(
                      createBook({
                        body: {
                          title: title,
                          materialType: selectedMaterial,
                          categoryType: selectedCategory,
                          collaborator: collaborator,
                          subjects: selected,
                        },
                        onSuccess: (res) => {
                          if (mode === "app") {
                            dispatch(
                              associateABook({
                                body: {
                                  bookId: res.data.data._id,
                                  classId: emptyClass?._id,
                                },
                                onSuccess: (response) => {
                                  dispatch(
                                    classInfo({
                                      onSuccess: () => {
                                        dispatch(all({ onSuccess: () => {} }));
                                        dispatch(
                                          show({
                                            onSuccess: () => {
                                              setIsLoading(false);
                                              setCreateNewBook(false);
                                              navigate(
                                                `/create/${res.data.data._id}`
                                              );
                                            },
                                            id: res.data.data._id,
                                          })
                                        );
                                      },
                                      onError: () => {},
                                    })
                                  );
                                },
                                onError: (err) => {
                                  setIsLoading(false);
                                  toast.error("Failed to associate a book.");
                                },
                              })
                            );
                          } else {
                            dispatch(all({ onSuccess: () => {} }));
                            dispatch(
                              show({
                                onSuccess: () => {
                                  setIsLoading(false);
                                  setCreateNewBook(false);
                                  navigate(`/create/${res.data.data._id}`);
                                },
                                id: res.data.data._id,
                              })
                            );
                          }
                        },
                        onError: (error) => {
                          setIsLoading(false);
                          if (
                            error.response &&
                            error.response.data &&
                            error.response.data.message
                          ) {
                            setError(error.response.data.message);
                          } else {
                            setError("Something went wrong!");
                          }
                        },
                      })
                    );
                  }}
                >
                  {isLoading ? "Loading..." : "Create book"}
                </button>
                <button
                  type="button"
                  className="btn-white-create"
                  onClick={() => {
                    setCreateNewBook(false);
                    setSelectOption(true);
                  }}
                >
                  Go back
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateNewBook;
